<template>
  <div class="pa-4">
    <h2 class="my-4">Web Socket Connection for Vendors</h2>

    <section id="Introduction  " ref="Introduction  ">
      <h4 class="py-3 primaryColor">Introduction</h4>
      <p class="pb-2">
        The <b>WebSocket API</b> is an advanced technology that makes it
        possible to open a two-way interactive communication session between the
        user's browser and a server. With this API, you can send messages to a
        server and receive event-driven responses without having to poll the
        server for a reply.
      </p>
      <p class="pb-2">
        With a WebSocket API, you can receive quotes for all scrips across all
        Indian Exchanges during the market hours. The feeds are usually
        classified into two categories, Market Feed and Depth Feed. For every
        new connection, you will receive an acknowledgment (usually represented
        as "tk") followed by the exchange feed (usually represented as "tf").
      </p>
    </section>

    <section id="Create Session" ref="Create Session">
      <h4 class="mb-2">Create Session</h4>
      <h5 class="mb-2">
        Create a new session using REST API (Authorization token is required as
        in the case of other API requests)
      </h5>
      <div class="fsize14 my-5 methodUrl">
        <span class="px-2 methodName">Post </span
        ><span class="pathUrl px-2">/ws/createWsSession</span>
      </div>
      <h4 class="font-weight-bold mb-2">Request</h4>
      <div class="mb-2">
        Parameters are as below (Payload). Use JSON content type
      </div>
      <pre><i>              {"loginType":"API"}          </i></pre>

      <div class="my-2">Auth headers as shown below</div>
      <v-card outlined class="pa-2 my-4">
        <h4 class="mb-2 fsize14">Request Headers</h4>
        <pre class="fsize13">
                 <b>Authorization: Bearer RC047 Fhrb2rt5G7Hav94X7aDZKObz2DPGVAIEQDoFcybzaeM4B3VmiYA3qbOtb4qUcRFYnHfuRGPRL3N9NZfUCc78Yrb5yFTg46dnlo
                 FlEUmOHOPzq7zGntAJARqDidhqk2rPDr08hgLqOR7TAnmeb5akhWnXuOyW1FyNAqCMMC82WdgiXI9VdKZRBTn5iMfV4Ur85
                 9plGDkjSbyV8iMpQAelCcm3l7Bb5DJfMnFnU7zUhhDv1eRsxmyXfBk1qWEprQNz</b>
             </pre>
      </v-card>
      <h4 class="my-3 fsize14">Response from Rest API</h4>
      <pre class="cls_pre login pa-3 fsize13 w-460 my-4">
                 {
                      "stat": "Ok",
                      "result": {
                      "wsSess": "8IRBQ1320KTPPEUXIVLU19TCG"
                       },
                      "message": "SUCCESS"
                 }</pre
      >
    </section>

    <section id="Create Connection" ref="Create Connection" class="mt-10">
      <h4 class="mb-2">Create Connection</h4>
      <h5 class="my-2">
        Create Connection to Web Socket using the following URL
      </h5>
      <v-card outlined flat max-width="450px" class="pa-3 my-4">
        <div class="blue--text fasize14">
          wss://ws1.aliceblueonline.com/NorenWS
        </div>
      </v-card>
      <h4 class="my-2 fsize14"><b>Request</b></h4>
      <pre class="my-3 fsize13">
                 {
                    "susertoken": sha256_encryption( sha256_encryption(session_id)),
                    "t": "c",
                    "actid": client_id+ "_API",
                    "uid": client_id + "_API",
                    "source": "API"
                 }
             </pre
      >
      <h4 class="my-2 fsize14"><b>Response from WS</b></h4>
      <pre class="cls_pre login pa-3 fsize13 w-460 my-2">
                     {"t":"cf","k":"OK"}

                     If validation fails, response will show as its failed

                     {"t":"cf","k":"failed"}
            </pre
      >
    </section>

    <section
      id="Subscribe to Market Data"
      ref="Subscribe to Market Data"
      class="mt-5"
    >
      <h4>Subscription to Market Data (LTP, Change, OHLC and Volume)</h4>
      <h4 class="my-4 fsize14"><b>Request</b></h4>
      <pre class="my-2 fsize13">
                  {"k":"NFO|54957#MCX|239484","t":"t"}
              </pre
      >
      <pre class="mb-2">
                  t = Type of request, t for tick data
                  k = Params for subscription with pipe ‘|’ delimited tokens and exchange. Token and
                  exchange should be separated with #
              </pre
      >
      <h4 class="my-4 fsize14"><b>Acknowledgement Response </b></h4>
      <pre
        class="cls_pre login pa-4 fsize13 my-2"
        style="max-width: fit-content"
      >
            {"t":"tk","pp":"2","ml":"1","e":"NFO","tk":"54957","ts":"NIFTY28JUL22C16600","ls":"50","ti":"0.05","c":
            42.20","lp":"84.00","pc":"99.05","ft":"1658911102","oi":"7606750","o":"37.65","h":"98.00","l":"22.0
            0","ap":"61.35","v":"129781850","bp1":"84.00","sp1":"84.20","bq1":"1000","sq1":"300"
            
            {"t":"tk","pp":"2","ml":"1","e":"MCX","tk":"239484","ts":"CRUDEOIL19SEP22","ls":"100","ti":"1.00","c"
            "7522.00","ft":"1658911100","v":"469","oi":"429","bp1":"7564.00","sp1":"7567.00","bq1":"1","sq1":"
            "7522.00","ft":"1658911100","v":"469","oi":"429","bp1":"7564.00","sp1":"7567.00","bq1":"1","sq1":"
              </pre
      >

      <h4 class="my-4 fsize14"><b>Feed Response</b></h4>
      <pre
        class="cls_pre login pa-4 fsize13 my-2"
        style="max-width: fit-content"
      >
            {"t":"tf","e":"NFO","tk":"54957","lp":"84.20","pc":"99.53","ft":"1658911102"}

            {"t":"tf","e":"NFO","tk":"54957","lp":"84.35","pc":"99.88","ft":"1658911103","v":"129787100","bp1":"
            84.30","sp1":"84.50","bq1":"1500","sq1":"350"}
              </pre
      >

      <pre class="my-3">
                                t - type, tf – tick feed, tk - tick acknowledgement
                                e -exchange
                                tk - token
                                lp – LTP (Last traded price)
                                pc – Percentage change
                                cv – change value (Absolute change in price)
                                v – volume
                                o – open
                                h – high
                                l – low
                                c – close
                                ap – Average Price
                                symbol – Symbol Name
             </pre
      >
    </section>

    <section
      id="Unsubscribe to Market Data"
      ref="Unsubscribe to Market Data"
      class="mt-5"
    >
      <h4>Un-Subscription to Market Data (LTP, Change, OHLC and Volume)</h4>
      <h4 class="my-4 fsize14"><b>Request</b></h4>
      <pre class="my-2 fsize13">
                  {"k":"NFO|54957#MCX|239484","t":"u"}
            </pre
      >
      <pre class="mb-2">
                         t = Type of request, u for Un-subscription
                         k = Params for subscription with pipe ‘|’ delimited tokens and exchange. Token and
                         exchange should be separated with #
              </pre
      >
      <h4 class="my-4 fsize14"><b>Response</b></h4>
      <pre
        class="cls_pre login pa-4 fsize13 my-2"
        style="max-width: fit-content"
      >
                No response will be coming for this. Unsubscribed tokens will no longer receive feed
            </pre
      >
    </section>

    <section id="Subscribe to Depth" ref="Subscribe to Depth" class="mt-5">
      <h4>Subscription to Depth data (LTP, Change, OHLC, OI and Volume)</h4>
      <h4 class="my-4 fsize14"><b>Request</b></h4>
      <pre class="my-2 fsize13">
                  {"k":"NFO|54957#MCX|239484","t":"d"}
              </pre
      >
      <pre class="mb-2">
                  t = Type of request, t for tick data
                  k = Params for subscription with pipe ‘|’ delimited tokens and exchange. Token and
                  exchange should be separated with #
              </pre
      >
      <h4 class="my-4 fsize14"><b>Acknowledgement Response </b></h4>
      <pre
        class="cls_pre login pa-4 fsize13 my-2"
        style="max-width: fit-content"
      >
            {"t":"dk","pp":"2","ml":"1","e":"NFO","tk":"54957","ts":"NIFTY28JUL22C16600","ls":"50","ti":"0.05","c":"42.20","lp":"76.40",
            "pc":"81.04","uc":"469.90","lc":"0.05","ft":"1658910517","oi
            ":"7361100","ltq":"50","o":"37.65","h":"98.00","l":"22.00","ap":"60.72","v":"125888500","ltt":"13:58:37","tbq":"965400","ts
            q":"980950","bp1":"76.30","sp1":"76.45","bp2":"76.25","sp2":"
            76.50","bp3":"76.20","sp3":"76.55","bp4":"76.15","sp4":"76.60","bp5":"76.10","sp5":"76.65","bq1":"50","sq1":"650","bq2":
            "2000","sq2":"1400","bq3":"3800","sq3":"2250","bq4":"2000","sq4":"3400","bq5":"7350","sq5":"2250","bo1":"1","so1":"2",
            bo2":"9","so2":"8","bo3":"22","so3":"12","bo4":"12","so4":"16","bo5":"17","so5":"7"}

            {"t":"dk","pp":"2","ml":"1","e":"MCX","tk":"239484","ts":"CRUDEOIL19SEP22","ls":"100","ti":"1.00","c":"7522.00","ft":"1658
            910516","v":"454","oi":"437","ltq":"1","tbq":"144","tsq":"119",
            "bp1":"7564.00","sp1":"7567.00","bp2":"7563.00","sp2":"7568.00","bp3":"7562.00","sp3":"7570.00","bp4":"7561.00","sp4":
            "7571.00","bp5":"7560.00","sp5":"7572.00","bq1":"1","sq1":"5","bq
            2":"1","sq2":"4","bq3":"5","sq3":"3","bq4":"4","sq4":"5","bq5":"3","sq5":"1","bo1":"1","so1":"3","bo2":"1","so2":"2","bo3":
            "5","so3":"1","bo4":"4","so4":"4","bo5":"3","so5":"1","52h":"8382.00","52l":"6966.00","lp":"7568.00","pc":"0.61","o":"7479.00",
            "h":"7588.00","l":"7479.00","ap":"7536.33","ltt":"13:58:12"}
              </pre
      >

      <h4 class="my-4 fsize14"><b>Feed Response</b></h4>
      <pre
        class="cls_pre login pa-4 fsize13 my-2"
        style="max-width: fit-content"
      >
            {"t":"df","e":"NFO","tk":"54957","lp":"76.55","pc":"81.40","ft":"1658910520","ltq":"200"}

            {"t":"df","e":"MCX","tk":"239484","ft":"1658910519","tsq":"117","sq1":"3","so1":"1"}
              </pre
      >

      <pre class="my-3">
                                t - type, dk – depth acknowledgement, df - depth feed
                                e - exchange
                                tk - token
                                lp – LTP (Last traded price)
                                pc – Percentage change
                                cv – change value (Absolute change in price)
                                v – volume
                                o – open
                                h – high
                                l – low
                                c – close
                                ap – Average Price
                                ts – Symbol Name
                                bp1,bp2,bp3,bp4,bp5 - Depth buy price
                                sp1,sp2,sp3,sp4,sp5 - Depth sell price
                                bq1,bq2,bq3,bq4,bq5 - Depth buy quantity
                                sq1,sq2,sq3,sq4,sq5 - Depth sell quantity
                                bo1,bo2,bo3,bo4,bo5 - Depth buy order
                                so1,so2,so3,so4,so5 - Depth sell order
                                oi = open interest
                                ltq - last traded qty
                                ltt - last traded time
                                tbq - total buy qty
                                tsq - total sell qty
                                uc - upper circuit
                                lc - lower circuit
             </pre
      >
    </section>

    <section id="Unsubscribe to Depth" ref="Unsubscribe to Depth" class="mt-5">
      <h4>Un-Subscription to Depth data (LTP, Change, OHLC and Volume)</h4>
      <h4 class="my-4 fsize14"><b>Request</b></h4>
      <pre class="my-2 fsize13">
                   {"k":"NFO|54957#MCX|239484","t":"ud"}
            </pre
      >
      <pre class="mb-2">
                         t = Type of request, ud for Un-subscription
                         k = Params for subscription with pipe ‘|’ delimited tokens and exchange. Token and
                         exchange should be separated with #
              </pre
      >
      <h4 class="my-4 fsize14"><b>Response</b></h4>
      <pre
        class="cls_pre login pa-4 fsize13 my-2"
        style="max-width: fit-content"
      >
                No response will be coming for this. Unsubscribed tokens will no longer receive feed
            </pre
      >
    </section>
    <section id="Order Status Feed" ref="Order Status Feed" class="mt-5">
      <h4>
        The Order Status Feed WebSocket API allows clients to receive real-time
        updates on their order status. The process involves an initial
        authentication to obtain an order token, followed by establishing a
        WebSocket connection using this token. Clients must maintain the
        connection by sending regular heartbeats to keep the connection alive.
      </h4>

      <h5 class="my-2 fsize14">Authentication</h5>
      <div class="fsize14 my-5 methodUrl">
        <span class="px-2 methodName">Get </span
        ><span class="pathUrl px-2">https://ant.aliceblueonline.com/order-notify/ws/createWsToken</span>
      </div>
      <h4 class="my-4 fsize14"><b>Headers</b></h4>
      <pre class="my-2 fsize13">
                   Authorization: Bearer &lt;your bearer token&gt;
            </pre
      >

      <h4 class="my-4 fsize14"><b>Response</b></h4>
      <pre
        class="cls_pre login pa-4 fsize13 my-2"
        style="max-width: fit-content"
      >
               {
                  "status": "Ok",
                  "message": "200",
                  "result":[
                    {
                      "orderToken": "23e16a457b4a035af850f4cf3f8da07e15cd7d7619a13b9d4c17ae33176"
                    }
                ]

               }

               Order token that will be used to establish the Websocket connection
            </pre
      >
      <h5 class="my-2 fsize14">Websocket Connection</h5>
      <h4 class="my-2 fsize14"><b>Step 2: Connect to Websocket</b></h4>
      <div class="fsize14 my-5 methodUrl">
        <span class="px-2 methodName">Get </span
        ><span class="pathUrl px-2">wss://ant.aliceblueonline.com/order-notify/websocket</span>
      </div>

      <h4 class="my-4 fsize14"><b>Request</b></h4>
      <p class="fsize13">
        After successful connection send order token and user ID to subscribe.
      </p>
      <pre class="my-2 fsize13">
        Sample Payload: 
            { 
            "orderToken": "23e16a457b4a035af850f4cf3f8da07e15cd7d7619a13b9d4c17ae33176",
            "userId": "123456" 
            } 
            </pre
      >

      <h4 class="my-4 fsize14"><b>Response</b></h4>
      <pre
        class="cls_pre login pa-4 fsize13 my-2"
        style="max-width: fit-content"
      >
        { 
            "status": "Ok" 
        } 

            Upon successful connection user with start receiving their order feeds. 
            </pre
      >
      <h5 class="my-2 fsize14">Heartbeat</h5>
      <h4 class="my-2 fsize14"><b>Step 3: Send Heartbeat</b></h4>

      <h4 class="my-4 fsize14"><b>Request</b></h4>
      <p class="fsize13">
        To maintain the WebSocket connection, clients must send a heartbeat
        message every minute.
      </p>
      <pre class="my-2 fsize13">
        Sample Payload: 
            { 
                "heartbeat": "h", 
                "userId":"123456"
            }
            </pre
      >

      <p class="fsize13">
        Notes: Failure to send a heartbeat every minute will result in the
        connection being closed. Clients must re-establish the connection if it
        is closed.
      </p>
      <h5 class="my-2 fsize14">Order Status Feed</h5>

      <h4 class="my-4 fsize14"><b>Request</b></h4>
      <p class="fsize13">
        Once connected, clients will receive real-time updates on their order
        status.
      </p>
      <pre class="my-2 fsize13">
        Sample Payload: 
           
            { 
                "t": "om", 
                "norenordno": "24070600000744",
                "uid": "1332014", 
                "actid": "1332014", 
                "qty": "1", 
                "prc": "0.00", 
                "pcode": "I", 
                "remarks": "", 
                "rejreason": "RED:Margin Shortfall:INR 28,030.64 Available:INR 29.36 for C-1332014 [ABFSFREEDOM]", 
                "prctyp": "MKT", 
                "ret": "DAY", 
                "dscqty": "0", 
                "trantype": "B", 
                "exch": "NSE", 
                "tsym": "MRF-EQ", 
                "status": "REJECTED", 
                "reporttype": "Rejected" 
            } 
            </pre
      >

      <p class="my-2 fsize13">
        Summary: <br />
        1. Authenticate: Obtain the `order_token` by calling `GET
        https://ant.aliceblueonline.com/order-notify/ws/createWsToken ` with a
        valid bearer token. <br />
        2. Connect: Establish a WebSocket connection to `
        wss://ant.aliceblueonline.com/order-notify/websocket` and send
        `orderToken` and `userId` to subscribe. <br />
        3. Heartbeat: Send a heartbeat message every minute to keep the
        connection alive. <br />
        4. Receive Updates: Listen for real-time order status updates. <br />

        Additional Notes: <br />
        Ensure your WebSocket client can handle reconnections in case of
        disconnections. <br />
        Maintain the security of your bearer token and order token at all times.
        <br />
        By following the steps outlined above, clients can successfully
        integrate with the Order Status Feed WebSocket API and receive timely
        updates on their orders.
      </p>
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({}),
  computed: {
    ...mapGetters({
      activeTab: "getActiveTab",
      scrolled: "getScrolled",
    }),
  },
  watch: {
    activeTab(val) {
      this.gotoSection(val);
    },
  },

  mounted() {
    this.gotoSection(this.$store.getters.getActiveTab);
  },

  methods: {
    gotoSection(refName) {
      var element = this.$refs[refName];
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
    onScroll(e) {
      this.$store.commit("setIsScroll", true);
      this.offsetTop = e.target.scrollTop;
      this.offsetTop > 500
        ? this.$store.commit("setScrolled", true)
        : this.$store.commit("setScrolled", false);
    },
  },
};
</script>

<style>
.height-25 {
  height: 25px !important;
}

.height-50 {
  height: 50px !important;
}

.w-460 {
  width: 460px !important;
}
</style>
